import { useMapped } from "@omni/utils/context/mapped.context";

import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";
import { TimerStatus } from "@/utils/hooks/timer/useTimer.types";

import { useProgressBarContext } from "../context/progressBar.context";
import { BarComponent } from "./bar.component";

const Bar = () => {
    const { index } = useMapped();
    const { activeIndex, delay, slideTo } = useBannerSliderContext();
    const { stopTimer, status } = useProgressBarContext();

    const isInitial = status === TimerStatus.Initial;
    const isRunning = status === TimerStatus.Running;
    const isStopped = status === TimerStatus.Stopped;
    const isActiveIndex = index === activeIndex;

    return (
        <BarComponent
            delay={delay}
            isRunning={isRunning}
            isActiveIndex={isActiveIndex}
            isStopped={isStopped}
            isInitial={isInitial}
            stopTimer={stopTimer}
            slideTo={slideTo}
            index={index}
        />
    );
};

export { Bar };
